export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_pfiynm8',
  TEMPLATE_ID: 'template_ir3pwwz',
  PUBLIC_KEY: 'pSTglibwLSaO-0w5f',
  TO_EMAIL: 'vmdpproject@gmail.com',
};
